export const HERO_UNIT_SCROLLED = 'HERO_UNIT_SCROLLED'
export const scrollHeroUnit = isScrolled => {
    return {
        type: HERO_UNIT_SCROLLED,
        isScrolled
    }
}

export const HERO_UNIT_MOBILE_SCROLLED = 'HERO_UNIT_MOBILE_SCROLLED'
export const scrollHeroUnitMobile = isScrolled => {
    return {
        type: HERO_UNIT_MOBILE_SCROLLED,
        isScrolled
    }
}

export const NAV_OPEN = 'NAV_OPEN'
export const openNav = isNavOpen => {
    return {
        type: NAV_OPEN,
        isNavOpen
    }
}

export const SET_NAV_HEIGHT = 'SET_NAV_HEIGHT'
export const setNavHeight = navHeight => {
    return {
        type: SET_NAV_HEIGHT,
        navHeight
    }
}

export const FOCUS_FILTER_INDUSTRY = 'FOCUS_FILTER_INDUSTRY'
export const focusFilterIndustry = isIndustryFilterFocused => {
    return {
        type: FOCUS_FILTER_INDUSTRY,
        isIndustryFilterFocused
    }
}

export const FOCUS_FILTER_LOCATION = 'FOCUS_FILTER_LOCATION'
export const focusFilterLocation = isLocationFilterFocused => {
    return {
        type: FOCUS_FILTER_LOCATION,
        isLocationFilterFocused
    }
}

export const SET_FILTER_SCROLL_OFFSET = 'SET_FILTER_SCROLL_OFFSET'
export const setFilterScrollOffset = scrollOffset => {
    return {
        type: SET_FILTER_SCROLL_OFFSET,
        scrollOffset
    }
}

export const OPEN_ABOUT_SECTION = 'OPEN_ABOUT_SECTION'
export const openAboutSection = isOpen => {
    return {
        type: OPEN_ABOUT_SECTION,
        isOpen
    }
}

export const ACTIVE_VIDEO_IDX = 'ACTIVE_VIDEO_IDX'
export const setActiveVideoIdx = activeVideoIdx => {
    return {
        type: ACTIVE_VIDEO_IDX,
        activeVideoIdx
    }
}


// WEBPACK FOOTER //
// ./src/actions/index.js